import React from 'react';
import { Link } from 'react-router-dom';
import { footerColumns, legalLinks } from '../../data/footerLinks';
import { Brand } from './Brand';
export function Footer() {
  return <footer className="relative border-t border-white/10 bg-ink" data-id="element-305" data-mp="am5ngq55zy8n">
      <div className="mx-auto max-w-8xl px-5 py-10 sm:px-8 lg:px-10" data-id="element-306" data-mp="akce33362zwy">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between" data-id="element-307" data-mp="5m150ukp4tfs">
          <div className="max-w-sm" data-id="element-308" data-mp="p1756y02wzr">
            <Brand data-id="element-309" data-mp="q2jdeqr5pj2" />
            <p className="mt-4 text-[13.5px] leading-relaxed text-mist-400" data-id="element-310" data-mp="3s2nfnt1f2xzf">
              Custom websites and connected web systems, designed, built, and managed by WebsiteForge since 2002.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-wrap gap-10 sm:gap-16" data-id="element-311" data-mp="3j2iiebpxtfyz">
            {footerColumns.map(col => <div key={col.heading} data-id="element-312" data-mp="3e1ksfcyorhmx">
                <h2 className="font-mono text-[11px] uppercase tracking-[0.18em] text-forge-cyan" data-id="element-313" data-mp="3e4qiauf52njp">{col.heading}</h2>
                <ul className="mt-3 space-y-2" data-id="element-314" data-mp="2kdd10pdv6tp3">
                  {col.links.map(link => <li key={link.label} data-id="element-315" data-mp="2p3teg9hoqfbg">
                      <Link to={link.to} className="text-[13.5px] text-mist-200 transition-colors hover:text-white" data-id="element-316" data-mp="2p4mp3ljrloyv">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}

            <div data-id="element-317" data-mp="340u6ke3sgcag">
              <h2 className="font-mono text-[11px] uppercase tracking-[0.18em] text-forge-cyan" data-id="element-318" data-mp="342f3299ny5ay">Contact</h2>
              <ul className="mt-3 space-y-2" data-id="element-319" data-mp="3825p5zo8vx95">
                <li data-id="element-320" data-mp="2u36c7pa3h6st">
                  <a href="tel:2312660606" className="text-[13.5px] text-mist-200 transition-colors hover:text-white" data-id="element-321" data-mp="2u3pj8ay7ias2">
                    231-266-0606
                  </a>
                </li>
                <li className="text-[13.5px] text-mist-400" data-id="element-322" data-mp="1in7u6vwxvafg">Phone, email, and ticket support</li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-323" data-mp="1nkhiu9ci7i28">
          <p className="text-[13px] text-mist-400" data-id="element-324" data-mp="zimag2dh5d28">© {new Date().getFullYear()} WebsiteForge. All rights reserved.</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-mist-400" data-id="element-325" data-mp="urmht9be1h5j">
            {legalLinks.map(l => <li key={l.label} data-id="element-326" data-mp="psta5xis8kda">
                <a href={l.to} target="_blank" rel="noreferrer" className="transition-colors hover:text-white" data-id="element-327" data-mp="pri4tt9ov4k2">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}